module.exports = __webpack_public_path__ + "static/media/1_A1_08.b3dd1257.png";